<template>
<div class="chapter">
<div class="inner_page">
<div class="acknowledgments" id="ack">
<h1 class="chapter"><a id="pagevii"></a>Acknowledgements</h1>
<p class="center"><img alt="" src="OEBPS/images/9780312382582_clogo1.png"/><br/><br/><br/><br/></p>
<p class="nonindent">Several friends helped with the writing of this novel: Cristina Monet Zilkha, Tessa Dahl, Sarah Standing, Pandora Delevingne, Julia Dixon and Victoria Mather, all of whom made penetrating observations on characterisation and plot. I would also like to thank Nick Allan who, as with previous novels, has been my special advisor on Asia, rock music and the financial markets, though he cannot be held responsible for errors where I have only partially followed his expert advice. I am grateful, too, to Georgina and William Petty and Monty Risenhoover of Moab, Utah, the late John Morgan, Vassi Chamberlain, Kathryn Greig, Kate Ancell, Sandy Swinton, Rupert Rucker, Julian Allason, Mary Iliff and James Alexander Sinclair, who respectively put me right on Midwest cattle ranches, classical music and pinstripes, social life in Lyford Cay, the internal routine of the Sotheby’s Client Relations department in New York, New Jersey suburbs, fund management in Moscow, Down’s Syndrome, secretarial employment agencies and landscape gardening. Harriet Robertson, Lucy Callingham, Bean McCall, Lisa Murray and Annabelle Hood kindly typed different stretches of the manuscript.</p>
<p class="indent">The brilliant editor, Rosie de Courcy, commissioned the novel in the first place and subsequently made suggestions which improved it beyond measure. My omnipresent agent, the great Ed Victor, was involved every step of the way.</p>
<p class="nonindent"><a id="pageviii"></a>Anthony Cheetham acted as godfather to the book, and Kirsty Fowkes was godmother. Lynn Curtis copyedited the manuscript.</p>
<p class="indent">As ever, I am hugely indebted to my wife, Georgia, who reads and edits early drafts of each chapter and cheerfully consents to discuss the various characters and their motivation <em>ad nauseam</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312382582_epub_ack_r1.vue?d85b0ac0